import { observer } from "mobx-react-lite"
import BlockBase from "./base"
import BlockState from "pages/scheme-editor/store/block"
import BlockInfo from "./base-info"
import React, { useLayoutEffect, useState } from "react"
import InputBlock from "components/controls/input-block"
import { FormControlLabel, Checkbox, IconButton } from "@mui/material"
import TargetIcon from "components/icons/other/target"
import { useSchemeEditorStore } from "pages/scheme-editor/store"
import { getLink } from "utils/other"

const BlockArray = observer(({ state }: { state: BlockState }) => {

  const store = useSchemeEditorStore()
  useLayoutEffect(() => {
    state.setEmitters([ "Массив" ])
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const [ isSelectElement, setIsSelectElement ] = useState(false)
  const selectElement = (e: React.MouseEvent) => {
    setIsSelectElement(true)
    store.selectElement(e).then((block) => {
      setIsSelectElement(false)
      if (!block || block.id === state.id) return
      state.setData('count', '@'+block.id)
    })
  }

  const link = getLink(state.data.count)

  return (
    <BlockBase state={state}>
      <BlockInfo state={state}>
        <InputBlock 
          sx={{ mt: 0.8, "input": { color: link? "primary.main": null } }} 
          value={ link? store.blocks.get(link)?.data.name: state.data.count }
          onChange={(e) => state.setData('count', (link && !parseInt(e.target.value))? "": e.target.value)}
          label="Кол-во элементов" 
          placeholder="Константа или ключ"
          adornment={(
            <IconButton onClick={e => selectElement(e)} size="small" sx={{ position: "absolute", right: 1, top: 21 }}>
              <TargetIcon sx={{ color: isSelectElement? "primary.main": "text.secondary" }}/>
            </IconButton>
          )}
        />
        <FormControlLabel sx={{ mr: 0 }} control={<Checkbox {...state.checkboxProps('hideCount')} />} label="Не создавать ключ с длиной" />
        { state.data['key']?.endsWith("s") && (
          <FormControlLabel 
            sx={{ mr: 0, height: 24, mb: 1 }} 
            control={<Checkbox {...state.checkboxProps('keepS')} />} 
            label="Оставлять 's' в дочерних" 
          />
        )}
        <InputBlock sx={{ mb: 1 }} {...state.dataProps('maxSize')} label="Макс. кол-во элементов" placeholder="Не ограничено"/>
        <InputBlock {...state.dataProps('startIndex')} label="Начинать массив с" placeholder="1" sx={{ mb: 1 }}/>
      </BlockInfo>
    </BlockBase>
  )
})

export default BlockArray